var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import { Form, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { LoadingSpinner } from 'components/Shared/Loading/LoadingSpinner/LoadingSpinner';
import { StyledButton } from 'components/Shared/StyledButton/StyledButton';
import { InputFieldType } from 'models/Input/InputModels';
import { PubInputField } from 'components/Shared/PubInputField/PubInputField';
import { determineChannelVal } from 'components/ProductBuild/ProductBuildSearchForm/ProductBuildSearchForm';
import { getFilteredProducts } from 'services/api/search-filter-build-products';
import { validate } from 'services/api/product-service';
import { B2B_CHANNEL, GSA_CHANNEL, REQUEST_TYPE_QUOTE } from 'utils/constants';
import { searchParamsHelper } from 'components/ProductBuild/searchParamsHelper';
import { useSnackbar } from 'context/snackbar/SnackBarProvider';
import { getUTCDateData } from '../helper';
import { ProductBuildSearchResultsMulti } from '../ProductBuildSearchResults/ProductBuildSearchResultsMulti';
import styles from './ProductBuildSearchFormMulti.module.scss';
export function ProductBuildSearchFormMulti() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f;
    var navigate = useNavigate();
    var setSnackbarAlert = useSnackbar().setSnackbarAlert;
    var _g = useState(false), isLoading = _g[0], setIsLoading = _g[1];
    var searchParams = useSearchParams()[0];
    var searchParamsMemo = useMemo(function () {
        var _a, _b, _c, _d;
        var sp = {
            text: (_a = searchParams.get('productNbr')) !== null && _a !== void 0 ? _a : '',
            date: (_b = searchParams.get('date')) !== null && _b !== void 0 ? _b : '',
            time: (_c = searchParams.get('time')) !== null && _c !== void 0 ? _c : '',
            rbv: (_d = searchParams.get('channel')) !== null && _d !== void 0 ? _d : '',
        };
        return sp;
    }, [searchParams]);
    var buildParams = useMemo(function () {
        var val = searchParamsHelper(false, searchParamsMemo.text, searchParamsMemo);
        return val;
    }, [searchParamsMemo]);
    var _h = useState({
        text: buildParams.text,
        date: buildParams.date,
        displayDate: buildParams.displayDate,
        time: buildParams.time,
        displayTime: buildParams.displayTime,
        rbv: buildParams.rbv,
    }), searchData = _h[0], setSearchData = _h[1];
    var location = useLocation();
    sessionStorage.setItem('rawMultiData', JSON.stringify(location.state));
    var _j = useState((_c = (_b = (_a = location.state) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.data), rawDataToPass = _j[0], setRawDataToPass = _j[1];
    var _k = useState((_f = (_e = (_d = location.state) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.resultsCount), totalCount = _k[0], setTotalCount = _k[1];
    useEffect(function () {
        if (!rawDataToPass) {
            handleSearchButtonClick();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleSearchDataValueChange = function (field, val) {
        var data = __assign({}, searchData);
        data[field] = val;
        if (field === 'date') {
            data.date = getUTCDateData(val, data.displayTime).date;
            data.displayDate = val;
        }
        else if (field === 'time') {
            var _a = getUTCDateData(data.displayDate, val), date = _a.date, time = _a.time;
            data.time = time;
            data.date = date;
            data.displayTime = val;
        }
        setSearchData(function () { return data; });
    };
    var disableButton = useMemo(function () { return !searchData.text || !searchData.date || !searchData.time; }, [searchData]);
    var handleSearchButtonClick = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var handle500Error, text, date, time, rbv, validateRsp, productVersion, callSearchAPI, validateResBody, searchResultRsp;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setIsLoading(true);
                    handle500Error = function () {
                        setIsLoading(false);
                        setSnackbarAlert({
                            message: 'Server Error - Please report the error to the PLS support board/help desk with details',
                            type: 'error',
                        });
                    };
                    text = searchData.text, date = searchData.date, time = searchData.time, rbv = searchData.rbv;
                    return [4 /*yield*/, validate({
                            productNbr: text,
                            requestType: REQUEST_TYPE_QUOTE,
                            processingDate: "".concat(date, "T").concat(time, ".000Z"),
                        })];
                case 1:
                    validateRsp = _d.sent();
                    if (validateRsp.status >= 500) {
                        handle500Error();
                        return [2 /*return*/];
                    }
                    productVersion = '';
                    callSearchAPI = true;
                    if (validateRsp.status === 200) {
                        validateResBody = validateRsp.body;
                        if (validateResBody.returnCode === '0') {
                            productVersion = (_a = validateResBody.productVersion) !== null && _a !== void 0 ? _a : '';
                            if ((rbv === GSA_CHANNEL && validateResBody.gsaInd === 'N') ||
                                (rbv === B2B_CHANNEL && validateResBody.b2bInd === 'N')) {
                                callSearchAPI = false;
                            }
                        }
                    }
                    if (!callSearchAPI) return [3 /*break*/, 3];
                    return [4 /*yield*/, getFilteredProducts(text, date, time, determineChannelVal(rbv))];
                case 2:
                    searchResultRsp = _d.sent();
                    if (searchResultRsp.status >= 500) {
                        handle500Error();
                        return [2 /*return*/];
                    }
                    if (searchResultRsp.status === 200 && searchResultRsp.data) {
                        setRawDataToPass((_b = searchResultRsp === null || searchResultRsp === void 0 ? void 0 : searchResultRsp.data) === null || _b === void 0 ? void 0 : _b.data);
                        setTotalCount((_c = searchResultRsp.data.resultsCount) !== null && _c !== void 0 ? _c : 0);
                        navigate("/product-build/multi?productNbr=".concat(text, "&date=").concat(date, "&time=").concat(time, "&channel=").concat(rbv), {
                            state: { data: searchResultRsp },
                        });
                    }
                    setIsLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    setTotalCount(0);
                    setIsLoading(false);
                    setRawDataToPass([]);
                    _d.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [searchData, navigate, setSnackbarAlert]);
    return (_jsxs(Form, { children: [_jsxs(Box, __assign({ className: styles.form }, { children: [_jsx("h1", __assign({ className: styles.title }, { children: "Product Build" })), _jsxs(Box, __assign({ className: styles.searchContainer, sx: { width: '40%' } }, { children: [_jsx(PubInputField, { labels: { left: 'Full or Partial Product Number', right: 'Required' }, fieldType: InputFieldType.STRING, fieldValue: searchData === null || searchData === void 0 ? void 0 : searchData.text, fieldValueUpdateHandler: function (e) { return handleSearchDataValueChange('text', e); }, formInputName: "productNbr", validations: { required: 'This is a required field' }, dirtyCheck: true, borderFocus: !!searchData.text && searchData.text !== '' }), _jsx(Box, __assign({ className: styles.rbContainer }, { children: _jsx(PubInputField, { fieldType: InputFieldType.RADIO, fieldValue: searchData.rbv, fieldOptions: ['Commercial', 'GSA', 'B2B'], fieldValueUpdateHandler: function (e) { return handleSearchDataValueChange('rbv', e); }, labels: { left: 'Channel' } }) }))] })), _jsx(Box, __assign({ className: styles.searchContainer }, { children: _jsx(PubInputField, { labels: { left: 'Date', right: 'Required' }, fieldType: InputFieldType.DATE, fieldValue: searchData === null || searchData === void 0 ? void 0 : searchData.displayDate, fieldValueUpdateHandler: function (e) { return handleSearchDataValueChange('date', e); }, formInputName: "date", validations: { required: 'This is a required field' }, dirtyCheck: true, showErrorAdornment: false, borderFocus: !!searchData.date }) })), _jsx(Box, __assign({ className: styles.searchContainer, sx: { width: '140px' } }, { children: _jsx(PubInputField, { labels: { left: 'Time', right: 'Required' }, fieldType: InputFieldType.TIME, fieldValue: searchData === null || searchData === void 0 ? void 0 : searchData.displayTime, fieldValueUpdateHandler: function (e) { return handleSearchDataValueChange('time', e); }, formInputName: "time", validations: { required: 'This is a required field' }, dirtyCheck: true, showErrorAdornment: false, borderFocus: !!searchData.time }) })), _jsx(Box, __assign({ className: styles.buttonContainer }, { children: _jsx(StyledButton, { type: "submit", labelText: "Search", height: "35px", disabled: disableButton, buttonAction: function () { return handleSearchButtonClick(); } }) }))] })), _jsx("hr", { className: styles.hr }), !isLoading && rawDataToPass ? (_jsx(ProductBuildSearchResultsMulti, { rawTableData: rawDataToPass, totalCount: totalCount })) : (_jsx(LoadingSpinner, { indicatorSize: 10 }))] }));
}
